(function () {
  const drawer = document.querySelector("[data-quick-atc-drawer]");
  const backdrop = document.querySelector("[data-quick-atc-backdrop]");

  if (!drawer || !backdrop) return;

  const loadingEl = drawer.querySelector("[data-quick-atc-loading]");
  const contentEl = drawer.querySelector("[data-quick-atc-content]");
  const closeBtn = drawer.querySelector("[data-quick-atc-close]");
  const carouselEl = drawer.querySelector("[data-quick-atc-carousel]");
  const slidesEl = drawer.querySelector("[data-quick-atc-slides]");
  const prevBtn = drawer.querySelector("[data-quick-atc-prev]");
  const nextBtn = drawer.querySelector("[data-quick-atc-next]");
  const metaEl = drawer.querySelector("[data-quick-atc-meta]");
  const titleEl = drawer.querySelector("[data-quick-atc-title]");
  const subtitleEl = drawer.querySelector("[data-quick-atc-subtitle]");
  const featuresEl = drawer.querySelector("[data-quick-atc-features]");
  const etrustedEl = drawer.querySelector("[data-quick-atc-etrusted]");
  const linkEl = drawer.querySelector("[data-quick-atc-link]");
  const optionRowEl = drawer.querySelector("[data-quick-atc-option-row]");
  const optionLabelEl = drawer.querySelector("[data-quick-atc-option-label]");
  const variantSelectEl = drawer.querySelector(
    "[data-quick-atc-variant-select]",
  );
  const priceEl = drawer.querySelector("[data-quick-atc-price]");
  const qtyDecreaseBtn = drawer.querySelector("[data-quick-atc-qty-decrease]");
  const qtyIncreaseBtn = drawer.querySelector("[data-quick-atc-qty-increase]");
  const qtyValueEl = drawer.querySelector("[data-quick-atc-qty-value]");
  const submitBtn = drawer.querySelector("[data-quick-atc-submit]");
  const submitTextEl = drawer.querySelector("[data-quick-atc-submit-text]");

  const requiredEls = [
    loadingEl,
    contentEl,
    closeBtn,
    slidesEl,
    variantSelectEl,
    priceEl,
    submitBtn,
    submitTextEl,
    qtyValueEl,
  ];
  if (requiredEls.some((el) => !el)) return;

  const moneyFormat = drawer.getAttribute("data-money-format") || "€{{amount}}";
  const selectOptionTemplate =
    drawer.getAttribute("data-t-select-option") || "";
  const translations = {
    adding: drawer.getAttribute("data-t-adding") || "...",
    added: drawer.getAttribute("data-t-added") || "✓",
    error: drawer.getAttribute("data-t-error") || "Error",
    soldOut: drawer.getAttribute("data-t-sold-out") || "Sold out",
  };
  const addToCartText = submitTextEl ? submitTextEl.textContent.trim() : "";

  let isOpen = false;
  let quantity = 1;
  let productData = null;
  let triggerElement = null;
  let emblaInstance = null;

  /* ── Utilities ───────────────────────────────────────────── */

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const amountWithComma = amount
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const amountNoDecimals = Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        amountNoDecimals,
      )
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals);
  }

  function getImageUrl(url, width) {
    if (!url) return "";
    let normalized = url;
    if (normalized.startsWith("//")) {
      normalized = `https:${normalized}`;
    }
    const separator = normalized.indexOf("?") !== -1 ? "&" : "?";
    return `${normalized + separator}width=${width}`;
  }

  function escapeHtml(text) {
    const div = document.createElement("div");
    div.appendChild(document.createTextNode(text));
    return div.innerHTML;
  }

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
  }

  /* ── Drawer open / close ─────────────────────────────────── */

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;

    drawer.classList.remove("translate-y-full", "lg:translate-x-full");
    drawer.classList.add("translate-y-0", "lg:translate-x-0");
    backdrop.classList.remove("opacity-0", "pointer-events-none");
    backdrop.classList.add("opacity-100", "pointer-events-auto");

    document.body.classList.add("overflow-hidden");
    drawer.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => {
      const focusable = getFocusableElements(drawer);
      if (focusable.length > 0) {
        focusable[0].focus();
      }
    });

    document.addEventListener("keydown", handleKeydown);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;

    drawer.classList.remove("translate-y-0", "lg:translate-x-0");
    drawer.classList.add("translate-y-full", "lg:translate-x-full");
    backdrop.classList.remove("opacity-100", "pointer-events-auto");
    backdrop.classList.add("opacity-0", "pointer-events-none");

    document.body.classList.remove("overflow-hidden");
    drawer.setAttribute("aria-hidden", "true");

    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }

    document.removeEventListener("keydown", handleKeydown);

    setTimeout(resetDrawer, 400);
  }

  function resetDrawer() {
    quantity = 1;
    productData = null;
    qtyValueEl.textContent = "1";
    if (emblaInstance) {
      emblaInstance.destroy();
      emblaInstance = null;
    }
    slidesEl.innerHTML = "";
    loadingEl.classList.remove("hidden");
    contentEl.classList.add("hidden");
    submitBtn.disabled = false;
    submitTextEl.textContent = addToCartText;
  }

  function handleKeydown(e) {
    if (e.key === "Escape") {
      closeDrawer();
    }

    if (e.key === "Tab") {
      const focusable = getFocusableElements(drawer);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ── Content population ──────────────────────────────────── */

  function getSelectedVariant() {
    if (!productData) return null;
    const id = parseInt(variantSelectEl.value, 10);
    return productData.variants.find((v) => {
      return v.id === id;
    });
  }

  function getVariantImagePositions(product) {
    const positions = new Set();
    product.variants.forEach((v) => {
      if (v.featured_image) {
        positions.add(v.featured_image.position);
      }
    });
    return positions;
  }

  function getNonVariantImages(product) {
    const variantPositions = getVariantImagePositions(product);
    return product.images.filter((_, index) => {
      return !variantPositions.has(index + 1);
    });
  }

  function updateCarouselButtons() {
    if (!emblaInstance) return;
    prevBtn.disabled = !emblaInstance.canScrollPrev();
    nextBtn.disabled = !emblaInstance.canScrollNext();
  }

  function renderImages(product, variantImageSrc) {
    if (emblaInstance) {
      emblaInstance.destroy();
      emblaInstance = null;
    }
    slidesEl.innerHTML = "";

    const nonVariantImages = getNonVariantImages(product);

    /* Slide list: variant image first, then non-variant images */
    const slides = [];
    if (variantImageSrc) {
      const matchingVariant = product.variants.find(
        (v) => v.featured_image && v.featured_image.src === variantImageSrc,
      );
      slides.push({
        src: variantImageSrc,
        alt: matchingVariant?.featured_image?.alt || product.title,
      });
    }
    nonVariantImages.forEach((url) => {
      slides.push({ src: url, alt: product.title });
    });

    if (slides.length === 0) {
      const placeholderTpl = drawer.querySelector(
        "[data-quick-atc-placeholder-image]",
      );
      if (placeholderTpl) {
        const slide = document.createElement("div");
        slide.className =
          "flex-[0_0_92%] md:flex-[0_0_85%] lg:flex-[0_0_70%] min-w-0 aspect-square flex items-center justify-center rounded-xl overflow-hidden";
        slide.appendChild(placeholderTpl.content.cloneNode(true));
        slidesEl.appendChild(slide);
      }
      return;
    }

    slides.forEach((slideData, index) => {
      const slide = document.createElement("div");
      slide.className =
        "flex-[0_0_92%] md:flex-[0_0_85%] lg:flex-[0_0_70%] min-w-0 aspect-square flex items-center justify-center rounded-xl overflow-hidden";

      const img = document.createElement("img");
      img.src = getImageUrl(slideData.src, 720);
      img.alt = slideData.alt;
      img.className = "w-full h-full object-contain";
      if (index > 0) {
        img.loading = "lazy";
      }
      slide.appendChild(img);
      slidesEl.appendChild(slide);
    });

    emblaInstance = window.EmblaCarousel(carouselEl, {
      loop: false,
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps",
    });

    updateCarouselButtons();
    emblaInstance.on("select", updateCarouselButtons);
    emblaInstance.on("reInit", updateCarouselButtons);
  }

  function renderBadge(badgeType) {
    if (!badgeType) return;
    const template = drawer.querySelector(`[data-badge-template-${badgeType}]`);
    if (template) {
      metaEl.appendChild(template.content.cloneNode(true));
    }
  }

  function renderRating(ratingValue, ratingMax, ratingCount) {
    if (!ratingCount || ratingCount <= 0) return;

    let fullStars = Math.floor(ratingValue);
    const decimal = ratingValue % 1;
    const hasHalf = decimal >= 0.25 && decimal < 0.75;
    if (decimal >= 0.75) {
      fullStars += 1;
    }
    let emptyStars = ratingMax - fullStars;
    if (hasHalf) {
      emptyStars -= 1;
    }

    const ratingEl = document.createElement("div");
    ratingEl.className = "flex gap-2 items-center";

    const starsEl = document.createElement("div");
    starsEl.className = "flex items-center gap-0.5";
    starsEl.setAttribute("role", "img");
    starsEl.setAttribute("aria-label", `${ratingValue} / ${ratingMax}`);

    const filledTpl = drawer.querySelector("[data-star-filled]");
    const halfTpl = drawer.querySelector("[data-star-half]");
    const emptyTpl = drawer.querySelector("[data-star-empty]");

    for (let i = 0; i < fullStars; i++) {
      starsEl.appendChild(filledTpl.content.cloneNode(true));
    }
    if (hasHalf) {
      starsEl.appendChild(halfTpl.content.cloneNode(true));
    }
    for (let j = 0; j < emptyStars; j++) {
      starsEl.appendChild(emptyTpl.content.cloneNode(true));
    }

    ratingEl.appendChild(starsEl);

    const countSpan = document.createElement("span");
    countSpan.className = "body text-primary";
    countSpan.textContent = `(${ratingCount})`;
    ratingEl.appendChild(countSpan);

    metaEl.appendChild(ratingEl);
  }

  function populateDrawer(product, triggerData) {
    productData = product;

    /* Images — variant image first, then non-variant images */
    const firstAvailableVariant = product.variants.find((v) => v.available);
    renderImages(product, firstAvailableVariant?.featured_image?.src || null);

    /* Meta (badge + rating) */
    metaEl.innerHTML = "";
    renderBadge(triggerData.badgeType);
    renderRating(
      parseFloat(triggerData.ratingValue) || 0,
      parseFloat(triggerData.ratingMax) || 5,
      parseInt(triggerData.ratingCount, 10) || 0,
    );

    /* Title + weight */
    let titleHtml =
      '<div class="flex flex-col gap-2 lg:flex-row lg:items-baseline justify-start">';
    titleHtml += `<h3 class="h3 uppercase text-primary">${escapeHtml(
      product.title,
    )}</h3>`;
    if (triggerData.weight) {
      titleHtml += `<span class="body text-subdued font-bold" data-quick-atc-weight>${escapeHtml(
        triggerData.weight,
      )}</span>`;
    }
    titleHtml += "</div>";
    titleEl.innerHTML = titleHtml;

    /* eTrusted widget — create fresh element so the web component initializes with the product SKUs */
    if (etrustedEl) {
      etrustedEl.innerHTML = "";
      const sku = product.variants.map((variant) => variant.sku).filter(Boolean).join(",");
      if (sku) {
        const widget = document.createElement("etrusted-widget");
        widget.setAttribute(
          "data-etrusted-widget-id",
          "wdg-7dad729a-c376-426c-99db-109e7e8e9615",
        );
        widget.setAttribute("data-sku", sku);
        etrustedEl.appendChild(widget);
      }
    }

    /* Subtitle */
    if (subtitleEl) {
      subtitleEl.textContent = triggerData.subtitle || "";
      subtitleEl.classList.toggle("hidden", !triggerData.subtitle);
    }

    /* Product USPs */
    if (featuresEl) {
      featuresEl.innerHTML = "";
      const checkTpl = drawer.querySelector("[data-check-circle-icon]");
      let features = [];
      try {
        features = JSON.parse(triggerData.features || "[]");
      } catch (_) {
        features = [];
      }
      if (features.length > 0 && checkTpl) {
        features.forEach((feature) => {
          const li = document.createElement("li");
          li.className = "flex items-center gap-2";
          li.appendChild(checkTpl.content.cloneNode(true));
          const span = document.createElement("span");
          span.className = "body text-primary";
          span.textContent = feature;
          li.appendChild(span);
          featuresEl.appendChild(li);
        });
        featuresEl.classList.remove("hidden");
      } else {
        featuresEl.classList.add("hidden");
      }
    }

    /* Product page link */
    linkEl.href = triggerData.productUrl || product.url;

    /* Variants */
    variantSelectEl.innerHTML = "";

    const isSingleDefault =
      product.variants.length === 1 &&
      product.variants[0].title === "Default Title";

    if (isSingleDefault) {
      optionRowEl.classList.add("hidden");
    } else {
      optionRowEl.classList.remove("hidden");
      const rawOption = product.options && product.options[0];
      const optionName =
        typeof rawOption === "string" ? rawOption : rawOption?.name || "";
      optionLabelEl.textContent = selectOptionTemplate.replace(
        "__OPTION__",
        optionName,
      );
    }

    product.variants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.title;
      if (!variant.available) {
        option.textContent += ` \u2013 ${translations.soldOut}`;
      }
      variantSelectEl.appendChild(option);
    });

    /* Select first available variant */
    const firstAvailable = product.variants.find((v) => {
      return v.available;
    });
    if (firstAvailable) {
      variantSelectEl.value = firstAvailable.id;
    }

    updatePrice();

    /* Reveal content */
    loadingEl.classList.add("hidden");
    contentEl.classList.remove("hidden");
  }

  /* ── Price update ────────────────────────────────────────── */

  function updatePrice() {
    const variant = getSelectedVariant();
    if (!variant) return;

    const isOnSale =
      variant.compare_at_price && variant.compare_at_price > variant.price;

    let priceHtml = "";
    priceHtml += `<span class="h5 uppercase font-bold ${
      isOnSale ? "text-discount" : "text-primary"
    }">`;
    priceHtml += formatMoney(variant.price);
    priceHtml += "</span>";

    if (isOnSale) {
      priceHtml += '<span class="body font-light line-through text-primary">';
      priceHtml += formatMoney(variant.compare_at_price);
      priceHtml += "</span>";
    }

    if (variant.unit_price_measurement) {
      priceHtml += '<span class="caption text-subdued">';
      priceHtml += `(${formatMoney(variant.unit_price)} / `;
      priceHtml +=
        variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
      priceHtml += ")</span>";
    }

    priceEl.innerHTML = priceHtml;

    /* Button state */
    submitBtn.disabled = !variant.available;
    submitTextEl.textContent = variant.available
      ? addToCartText
      : translations.soldOut;

    /* Swap first slide to selected variant image and scroll to it */
    if (variant.featured_image) {
      const firstSlideImg = slidesEl.querySelector("div:first-child img");
      if (firstSlideImg) {
        firstSlideImg.src = getImageUrl(variant.featured_image.src, 720);
        firstSlideImg.alt = variant.featured_image.alt || productData.title;
      }
      if (emblaInstance) {
        emblaInstance.scrollTo(0);
      }
    }
  }

  /* ── Cart operations ─────────────────────────────────────── */

  function addToCart() {
    const variant = getSelectedVariant();
    if (!variant || !variant.available) return;

    submitBtn.disabled = true;
    submitTextEl.textContent = translations.adding;

    fetch(`${window.routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variant.id,
        quantity,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(() => {
        submitTextEl.textContent = translations.added;
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        closeDrawer();
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("cart:open"));
        }, 400);
      })
      .catch(() => {
        submitTextEl.textContent = translations.error;
        setTimeout(() => {
          submitBtn.disabled = false;
          submitTextEl.textContent = addToCartText;
        }, 2000);
      });
  }

  /* ── Event listeners ─────────────────────────────────────── */

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-quick-atc-trigger]");
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    triggerElement = trigger;

    const handle = trigger.getAttribute("data-product-handle");
    if (!handle) return;

    const triggerData = {
      productUrl: trigger.getAttribute("data-product-url") || "",
      badgeType: trigger.getAttribute("data-badge-type") || "",
      ratingValue: trigger.getAttribute("data-rating-value") || "",
      ratingMax: trigger.getAttribute("data-rating-max") || "",
      ratingCount: trigger.getAttribute("data-rating-count") || "",
      subtitle: trigger.getAttribute("data-subtitle") || "",
      features: trigger.getAttribute("data-features") || "[]",
      weight: trigger.getAttribute("data-weight") || "",
    };

    quantity = 1;
    qtyValueEl.textContent = "1";
    loadingEl.classList.remove("hidden");
    contentEl.classList.add("hidden");

    openDrawer();

    fetch(`${window.shopUrl}/products/${handle}.js`)
      .then((res) => {
        if (!res.ok) throw new Error("Product fetch failed");
        return res.json();
      })
      .then((product) => {
        populateDrawer(product, triggerData);
      })
      .catch(() => {
        loadingEl.innerHTML = `<p class="body text-discount">${escapeHtml(
          translations.error,
        )}</p>`;
        setTimeout(closeDrawer, 2000);
      });
  });

  closeBtn.addEventListener("click", closeDrawer);
  backdrop.addEventListener("click", closeDrawer);
  variantSelectEl.addEventListener("change", updatePrice);

  prevBtn.addEventListener("click", () => {
    if (emblaInstance) emblaInstance.scrollPrev();
  });
  nextBtn.addEventListener("click", () => {
    if (emblaInstance) emblaInstance.scrollNext();
  });

  qtyDecreaseBtn.addEventListener("click", () => {
    if (quantity > 1) {
      quantity -= 1;
      qtyValueEl.textContent = quantity;
    }
  });

  qtyIncreaseBtn.addEventListener("click", () => {
    quantity += 1;
    qtyValueEl.textContent = quantity;
  });

  submitBtn.addEventListener("click", addToCart);

  /* ── Swipe-to-dismiss (mobile bottom sheet) ─────────────── */

  const dragHandleEl = drawer.querySelector("[data-quick-atc-drag-handle]");
  if (dragHandleEl) {
    let dragStartY = 0;
    let dragDeltaY = 0;
    let isDraggingSheet = false;

    dragHandleEl.addEventListener(
      "touchstart",
      (e) => {
        if (window.matchMedia("(min-width: 1024px)").matches) return;
        isDraggingSheet = true;
        dragStartY = e.touches[0].clientY;
        dragDeltaY = 0;
        drawer.style.transition = "none";
      },
      { passive: true },
    );

    dragHandleEl.addEventListener(
      "touchmove",
      (e) => {
        if (!isDraggingSheet) return;
        dragDeltaY = e.touches[0].clientY - dragStartY;
        if (dragDeltaY > 0) {
          drawer.style.transform = `translateY(${dragDeltaY}px)`;
        }
      },
      { passive: true },
    );

    dragHandleEl.addEventListener("touchend", () => {
      if (!isDraggingSheet) return;
      isDraggingSheet = false;
      drawer.style.transition = "";
      drawer.style.transform = "";
      if (dragDeltaY > 80) {
        closeDrawer();
      }
      dragDeltaY = 0;
    });
  }
})();
